import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { BaseService } from '../shared-service/base.service';
declare var jquery: any;
declare var $: any;

@Component({
	selector: 'app-main-container',
	templateUrl: './main-container.component.html',
	styleUrls: ['./main-container.component.css']
})


export class MainContainerComponent implements OnInit {
	
	showNavBar:boolean=false;
	constructor(private router: Router,private bs:BaseService) {
		this.bs.log('info',"Loaded MainContainerComponent");
	}

	ngOnInit() {
		
		this.bs.log('info',"ngOnInit MainContainerComponent");
		$("#footerSpan").append(this.bs.getResource("rbkey_CpyRghtMSG"));
		//code for privacy policy
		if (this.bs.getUserAttr("TermCondition") != '') {			
			$("#footerSpan").append("<a  target=\"_blank\" href=\"" +this.bs.getUserAttr("TermCondition")+"\" > | "+this.bs.getResource("rbkey_TrmCndtnLBL") +"</a>");
		}
		if (this.bs.getUserAttr("PrivacyPolicy") != '') {			
			$("#footerSpan").append("<a  target=\"_blank\" href=\"" +this.bs.getUserAttr("PrivacyPolicy")+"\" > | "+this.bs.getResource("rbkey_PrvcyPlcyLBL")+"</a>");
		}
		this.bs.getUserAtibuteLoded().subscribe((value: boolean) => {		
			if (value) {	  
			  this.showNavBar=true;	  
			}	  
		  });
	
	}

	onActivate(event:any) {
		this.bs.log('info',"MainContainerComponent Router Active");
		this.bs.log('info',event);
	};

	onDeactivate(event:any) {
		this.bs.log('info',"MainContainerComponent Router InActive");
		this.bs.log('info',event);
	};
}
